import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/adminPanel.css";
import config from "../config"; // Импортируем API_URL

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("groups");
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [newGroupName, setNewGroupName] = useState("");
  const [newUserId, setNewUserId] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null); 

  useEffect(() => {
    fetchUserRole();
  }, []);

  const fetchUserRole = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/user_info`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setRole(response.data.role);
      setCurrentUser(response.data); // Сохраняем user в состояние
      fetchGroups(response.data); //  Передаем user в fetchGroups
    } catch (error) {
      console.error("Ошибка загрузки данных пользователя:", error);
    }
  };

  const fetchGroups = async (user) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/groups`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      console.log("Полученные группы:", response.data); // Логируем полученные данные
  
      let availableGroups = response.data;
      if (user.role === "moderator") {
        availableGroups = response.data.filter((group) => group.creator_id === user.telegram_user_id);
      }
  
      console.log("Отфильтрованные группы:", availableGroups); // Логируем, что осталось после фильтрации
  
      setGroups(availableGroups);
      setLoading(false);
    } catch (error) {
      console.error("Ошибка загрузки групп:", error);
    }
  };
  
  const fetchUsers = async (groupId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/group_users/${groupId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(response.data);
    } catch (error) {
      console.error("Ошибка загрузки пользователей группы:", error);
    }
  };

  const fetchSchedule = async (groupId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/group_schedule/${groupId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSchedule(response.data);
    } catch (error) {
      console.error("Ошибка загрузки расписания:", error);
    }
  };

  const handleAddGroup = async () => {
    if (!newGroupName.trim()) return;
    setLoading(true);
  
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${config.API_URL}/groups/add`,
        { name: newGroupName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      setNewGroupName(""); // Очищаем поле ввода
      await fetchGroups(currentUser); // Обновляем группы
    } catch (error) {
      console.error("Ошибка при добавлении группы:", error);
    } finally {
      setLoading(false);
    }
  };
  
  

  const handleDeleteGroup = async (groupId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${config.API_URL}/groups/delete/${groupId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setGroups(groups.filter((group) => group.id !== groupId)); // Обновляем список без перезагрузки
      if (selectedGroup?.id === groupId) setSelectedGroup(null); // Если удалили выбранную группу, сбрасываем
    } catch (error) {
      console.error("Ошибка при удалении группы:", error);
    }
  };

  const handleAddUserToGroup = async () => {
    if (!newUserId.trim() || !selectedGroup) return;
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${config.API_URL}/group/add_user`, {
        telegram_user_id: newUserId,
        group_id: selectedGroup.id
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNewUserId("");
      fetchUsers(selectedGroup.id);
    } catch (error) {
      console.error("Ошибка при добавлении пользователя в группу:", error);
    }
  };
  const handleAssignLeader = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${config.API_URL}/groups/assign_leader`, { user_id: userId }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUsers(selectedGroup.id);
    } catch (error) {
      console.error("Ошибка при назначении лидера:", error);
    }
  };

  const handleAssignModerator = async (userId) => {
    if (role !== "admin") return;
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${config.API_URL}/groups/assign_moderator`, { user_id: userId }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUsers(selectedGroup.id);
    } catch (error) {
      console.error("Ошибка при назначении модератора:", error);
    }
  };
  const handleRemoveUser = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${config.API_URL}/groups/remove_user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(users.filter(user => user.id !== userId));
    } catch (error) {
      console.error("Ошибка при удалении пользователя:", error);
    }
  };

  const handleResetRole = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${config.API_URL}/groups/reset_role`, { user_id: userId }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUsers(selectedGroup.id);
    } catch (error) {
      console.error("Ошибка при сбросе роли пользователя:", error);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="admin-panel">
      <h2 className="main-text">Админ-меню</h2>

      <div className="tabs">
        <button className={`tab-btn ${activeTab === "groups" ? "active" : ""}`} onClick={() => handleTabChange("groups")}>
          🏫 Группы
        </button>
        <button className={`tab-btn ${activeTab === "users" ? "active" : ""}`} onClick={() => handleTabChange("users")}>
          👥 Пользователи
        </button>
        <button className={`tab-btn ${activeTab === "schedule" ? "active" : ""}`} onClick={() => handleTabChange("schedule")}>
          📅 Расписание
        </button>
      </div>

      <div className="tab-content">
        {activeTab === "groups" && (
          <div>
            <h3 className="second-text">Управление группами</h3>
            <input
              type="text"
              placeholder="Название группы"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
            />
            <button className="tab-btn" onClick={handleAddGroup}>➕ Добавить группу</button>
            {loading ? <p>Загрузка...</p> : groups.map((group) => (
              <div key={group.id} className={`group-item ${selectedGroup?.id === group.id ? "selected" : ""}`}
                onClick={() => { setSelectedGroup(group); fetchUsers(group.id); fetchSchedule(group.id); }}>
                <span className="second-text">{group.name}</span>
                <button className="delete-btn" onClick={() => handleDeleteGroup(group.id)}>🗑 Удалить</button>
              </div>
            ))}
          </div>
        )}

      <div className="tab-content">
        {activeTab === "users" && selectedGroup && (
          <div>
            <h3 className="second-text">Пользователи группы {selectedGroup.name}</h3>
            <input
              type="text"
              placeholder="Telegram ID пользователя"
              value={newUserId}
              onChange={(e) => setNewUserId(e.target.value)}
            />
            <button className="tab-btn" onClick={handleAddUserToGroup}>➕ Добавить</button>
            {users.map((user) => (
              <div key={user.id} className="user-item">
                <span className="second-text">{user.username} (ID: {user.telegram_user_id}) - {user.role}</span>
                <button className='tab-btn' onClick={() => handleAssignLeader(user.id)}>👑 Лидер</button>
                {role === "admin" && <button className='tab-btn' onClick={() => handleAssignModerator(user.id)}>🛠 Модератор</button>}
                <button className='tab-btn' onClick={() => handleResetRole(user.id)}>🔄 Сбросить роль</button>
                <button className="delete-btn" onClick={() => handleRemoveUser(user.id)}>❌ Удалить</button>
              </div>
            ))}
          </div>
        )}
      </div>
            

        {activeTab === "schedule" && selectedGroup && (
          <div className="shedule-admin">
            <h3 className="second-text">Расписание группы {selectedGroup.name}</h3>
            {schedule.length === 0 ? (
              <p>Нет данных</p>
            ) : (
              schedule.map((lesson) => (
                <div key={lesson.id} className="schedule-item">
                  <span className="second-text">
                    {lesson.weekday} | {lesson.start_time} - {lesson.end_time} | {lesson.subject} | {lesson.classroom} | {lesson.teacher}
                  </span>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;
